import { useEffect, useRef, useState } from "react";

const SearchableDropdown = ({
  options,
  extraoption,
  label,
  id,
  selectedVal,
  handleChange,
}) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", toggle);
    return () => document.removeEventListener("click", toggle);
  }, []);

  const selectOption = (option) => {
    setQuery(() => "");
    if (option) {
      handleChange({ id: option[id], name: option[label] });
    }
    setIsOpen((isOpen) => !isOpen);
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    if (query) return query;
    if (selectedVal) return selectedVal;

    return "";
  };

  const filter = (options) => {
    return (
      options &&
      options.filter(
        (option) =>
          option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
      )
    );
  };

  return (
    <div className="dropdown">
      <div className="control">
        <div className="selected-value">
          <input
            ref={inputRef}
            type="text"
            value={getDisplayValue()}
            name="searchTerm"
            onChange={(e) => {
              setQuery(e.target.value);
              if (e.target.value) {
                handleChange({ id: null, name: null });
              }
            }}
            onClick={toggle}
          />
        </div>
        <div className={`arrow ${isOpen ? "open" : ""}`}></div>
      </div>
      <div className={`options ${isOpen ? "open" : ""}`}>
        {options && filter(options).map((option, index) => {
          return (
            <div
              onClick={() => selectOption(option)}
              className={`option ${
                option[label] === selectedVal ? "selected" : ""
              }`}
              key={`${id}-${index}`}
            >
              {option[label]}
            </div>
          );
        })}
        {extraoption ? (
          <div
            onClick={() => selectOption(extraoption)}
            className={`option ${
              extraoption[label] === selectedVal ? "selected" : ""
            }`}
            key={`0-0`}
          >
            {extraoption[label]}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SearchableDropdown;
